<v-form @submit.prevent="submit" ref="form">
    <v-text-field
        variant="outlined"
        validate-on-blur
        :label="emailData.label"
        placeholder="Enter email address"
        :rules="emailData.rules"
        v-model="email"
        persistent-placeholder
    ></v-text-field>
    <v-text-field
        type="password"
        variant="outlined"
        validate-on-blur
        :label="passwordData.label"
        placeholder="Your password"
        :rules="passwordData.rules"
        v-model="password"
        persistent-placeholder
    ></v-text-field>
    <div class="d-flex justify-space-between">
        <v-btn type="submit" depressed tile color="primary" :loading="loading">
            Login
        </v-btn>
        <v-btn text @click="resetPassword">Forgot your password?</v-btn>
    </div>
</v-form>
